<template>
  <table class="products-pxsdb-features-view">
    <thead>
      <tr>
        <th>Key</th>
        <th class='even'>Name</th>
        <th>Values</th>
      </tr>
    </thead>
    <tbody v-if="entries">
      <tr
        v-for="feature in entries"
        :key="feature.key"
      >
        <td>
          {{ feature.key }}
        </td>
        <td class='even'>
          {{ feature.name }}
        </td>
        <td class="value">
          <ul class='values'>
            <li
              v-for="(value, index) in feature.values"
              :key="index"
            >
              {{value}}
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import productFamilyPxsdbFeatures
  from '@/api/queries/product-family-pxsdb-features.graphql';

export default {
  name: 'products-pxsdb-features-view',
  mixins: [Authentication],
  props: {
    productFamily: Object,
  },
  apollo: {
    productFamilyPxsdbFeatures: {
      query: productFamilyPxsdbFeatures,
      variables() {
        return {
          id: this.productFamily.id,
        };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  computed: {
    entries() {
      return (
        (this.productFamilyPxsdbFeatures &&
          this.productFamilyPxsdbFeatures.entries) ||
        []
      );
    },
  },
};
</script>

<style lang="scss">
  table.products-pxsdb-features-view {
    th, td {
      text-align: left; 
      vertical-align: top; 
      padding: 0.1ex 0.3ex;
    }   
    td.even, th.even {
      background-color: #f0f0f0
    }
    td.values ul {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// PxsdbFeaturesView.vue?f9509120